import React from "react";

const InsightsBoldNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.75 9.75H6.25L8.25 2.75L11.75 17.25L13.75 9.75H17.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(InsightsBoldNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;